import React, { Component } from 'react';
import { DatePicker, Row, Col, TreeSelect } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../category/redux/actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

export class Search extends Component {

  constructor(props) {
    super(props);
  };

  static propTypes = {

  };

  componentDidMount() {
    this.props.actions.getCategories('ALL');
  };

  render() {
    const parseData = (list) => {
      if (!list || typeof list !== "object" || Object.keys(list).length === 0 || !list["undefined"])
        return [];

      const parse = (item) => ({
        title: item.name,
        value: item.name,
        key: item.id,
      })

      return list["undefined"].map((item) => {
        let obj = parse(item);

        if (!list[item.id])
          return obj;

        obj.children = list[item.id].map(item => parse(item))

        return obj;
      })
    }

    const treeData = parseData(_.groupBy(_.sortBy(this.props.category.list, ['name']), 'parentCategory'))

    return (
      <div className="event-search form-front">
        <Row gutter={16}>
          <Col className="gutter-row" md={{ span: 24 }} lg={{ span: 12 }} >
            <div className="gutter-box">
              <TreeSelect
                treeData={treeData}
                showSearch
                searchPlaceholder="Toutes les catégories"
                treeCheckable
                multiple
                allowClear
                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                style={{ width: '100%' }}
                onChange={this.props.select}
                dropdownStyle={{ maxHeight: '200px' }}
              //filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              //value={this.props.categoriesSelected}
              //tokenSeparators={[',']}
              />
            </div>
          </Col>
          <Col className="gutter-row" style={{ marginTop: '-5px' }} md={{ span: 24 }} lg={{ span: 6 }}>
            <div className="gutter-box ">
              <DatePicker
                placeholder="Date de début"
                onChange={this.props.fromDate}
              />
            </div>
          </Col>
          <Col className="gutter-row" style={{ marginTop: '-5px' }} md={{ span: 24 }} lg={{ span: 6 }}>
            <div className="gutter-box">
              <DatePicker
                placeholder="Date de fin"
                onChange={this.props.toDate}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}


/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    category: state.category,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);



// WEBPACK FOOTER //
// ./src/features/event/Search.js